module.exports = __webpack_public_path__ + "static/img/WechatIMG113.f852519.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WechatIMG113.png
// module id = 7SI5
// module chunks = 1